<section class="w-full">
  <header class="l-flex l-align-y l-align-spaceBetween">
    <h2 class="t-widgetTitle">
      {{ "translate.dashboard.editBannersTitle" | translate }}
    </h2>
    <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
  </header>
  <hr />
</section>

<div class="body-container" cdkDropList (cdkDropListDropped)="drop($event)">
  <div *ngFor="let i of data" cdkDrag>
    <div class="banner-item">
      <div class="icon-navigate" cdkDragHandle>
        <img src="assets\img\Arrange_Order.svg" />
      </div>

      <img [src]="i.imgUrl" class="img-banner" />

      <div class="icon-navigate">
        <img src="assets\img\Delete.svg" (click)="deleteItem(i)" />
      </div>
    </div>
    <div class="l-align-spaceBetween">
      <input-wrap cssClass="l-cell-spread">
        <input
          type="text"
          [(ngModel)]="i.linkUrl"
          class="t-input t-input--colored"
          placeholder="{{ 'translate.dashboard.bannerUrl' | translate }}"
        />
      </input-wrap>

      <input-wrap>
        <p-datepicker
          dateFormat="dd/mm/yy"
          [(ngModel)]="i.validUntilDate"
          readonlyInput="readonlyInput"
          showButtonBar="true"
          placeholder="{{ 'translate.dashboard.validUntilDate' | translate }}"
        ></p-datepicker>
      </input-wrap>
    </div>
  </div>
</div>

<p class="t-footnote">
  {{ "translate.dashboard.uploadBannerInstruct" | translate }}
</p>

<div class="t-panel-cell t-buttonSet l-align-end">
  <spinner *ngIf="isUploading"></spinner>
  <input-wrap
    *ngIf="!isUploading"
    [customValidation]="isValidFile"
    customValidationWarn="{{ invalidFileWarn | translate }}"
    [cssClass]="'l-ta-center input-wrap-hasFileSpread'"
  >
    <input
      id="uploadFileInput"
      (change)="uploadFile($event)"
      class="t-fileInput-spread"
      type="file"
      accept=".jpg"
    />

    <button [disabled]="saving" class="t-button-outline">
      {{ "translate.dashboard.addBanner" | translate }}
    </button>
  </input-wrap>

  &nbsp; &nbsp;

  <spinner *ngIf="saving"></spinner>
  <button
    [disabled]="saving || isUploading"
    (click)="save()"
    class="t-button-outline inverted"
  >
    {{ "translate.general.save" | translate }}
  </button>
</div>
